import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { AuthLayout } from 'entities/Auth/layout/AuthLayout'
import { LoginPage } from 'pages/auth/pages/login'
import { ForgotPage } from 'pages/auth/pages/forgot'
import { ResetPage } from 'pages/auth/pages/reset'
import { AcceptPage } from 'pages/auth/pages/accept'
import { AgencyPage } from 'pages/auth/pages/agency'
import { AuthRoutes } from 'pages/auth/route/type'
import PageNotFound from 'pages/pageNotFound'

export const AuthRouter = observer(() => {
  return (
    <Routes>
      <Route path={`/${AuthRoutes.reset}/:token`} element={<ResetPage />} />
      <Route path={`/${AuthRoutes.accept}/:token`} element={<AcceptPage />} />
      <Route path={`/${AuthRoutes.agency}/:token`} element={<AgencyPage />} />

      <Route element={<AuthLayout />}>
        <Route path={`/${AuthRoutes.login}`} element={<LoginPage />} />
        <Route path={`/${AuthRoutes.forgot}`} element={<ForgotPage />} />
      </Route>

      <Route path='/*' element={<PageNotFound />} />
    </Routes>
  )
})
